import React, { useCallback } from 'react';
import { SvgIcon } from '@progress/kendo-react-common';
import { InputPrefix, TextBoxChangeEvent, TextBoxProps } from '@progress/kendo-react-inputs';
import { searchIcon } from '@progress/kendo-svg-icons';
import debounce from 'lodash/debounce';
import { TextBox } from '@components-clean/core/text-box';

interface SearchBoxProps extends TextBoxProps {
    'data-testid': string;
    showSearchIcon?: boolean;
    debounceTime?: number;
}

export const SearchBox = ({
    'data-testid': testid,
    showSearchIcon,
    value,
    onChange,
    debounceTime,
    ...props
}: SearchBoxProps) => {
    const debouncedOnChange = useCallback(
        debounce((e: TextBoxChangeEvent) => onChange?.(e), debounceTime),
        [],
    );

    const prefixComponent = () => (
        <InputPrefix>
            <SvgIcon icon={searchIcon} size="large" className="k-ml-2" />
        </InputPrefix>
    );

    return (
        <TextBox
            {...props}
            data-testid={testid}
            type="text"
            value={value}
            prefix={showSearchIcon ? prefixComponent : undefined}
            ignoreReadonlyContext
            onChange={(event: TextBoxChangeEvent) => {
                const stringValue = Array.isArray(event.value)
                    ? (event.value as string[])[0]
                    : event.value
                      ? event.value.toString()
                      : '';

                if (stringValue === '' || !debounceTime) {
                    debouncedOnChange.cancel();
                    onChange?.(event);
                } else {
                    debouncedOnChange(event);
                }
            }}
        />
    );
};
